/* @flow */
import Columns from 'components/Columns.jsx';
import GroupAvatarCluster from 'groups/components/GroupAvatarCluster.jsx';
import LinkConstants from 'constants/LinkConstants';
import OrganizationProfileTeacher from 'entities/OrganizationProfileTeacher';
import React from 'react';

import './styles/SchoolTeacherListItem.scss';

class SchoolTeacherListItem extends React.Component {
  static propTypes = {
    onGroupAvatarClick: React.PropTypes.func.isRequired,
    teacher: React.PropTypes.instanceOf(OrganizationProfileTeacher).isRequired,
  };

  render() {
    return (
      <div className="SchoolTeacherListItem">
        <Columns>
          <div className="SchoolTeacherListItem-signature">
            {this.props.teacher.getSignature()}
          </div>
          <GroupAvatarCluster
            groups={this.props.teacher.groupClusterItems}
            maxSize={3}
            moreButtonHref={LinkConstants.SIGN_UP}
            onGroupAvatarClick={this.props.onGroupAvatarClick}
          />
        </Columns>
      </div>
    );
  }
}

export default SchoolTeacherListItem;



// WEBPACK FOOTER //
// ./src/schools/components/SchoolTeacherListItem.jsx